var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1022 15.5366H5.06564C4.56956 15.5366 4.16748 15.1345 4.16748 14.6384C4.16748 14.1423 4.56956 13.7402 5.06564 13.7402H17.1019C17.5979 13.7402 18 14.1423 18 14.6384C18 15.1345 17.5982 15.5366 17.1022 15.5366Z",
    fill: "#1E2228"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1022 9.89983H5.06564C4.56956 9.89983 4.16748 9.49776 4.16748 9.00167C4.16748 8.50559 4.56956 8.10352 5.06564 8.10352H17.1019C17.5979 8.10352 18 8.50559 18 9.00167C18.0003 9.49776 17.5982 9.89983 17.1022 9.89983Z",
    fill: "#1E2228"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1022 4.26116H5.06564C4.56956 4.26116 4.16748 3.85909 4.16748 3.363C4.16748 2.86692 4.56956 2.46484 5.06564 2.46484H17.1019C17.5979 2.46484 18 2.86692 18 3.363C18 3.85909 17.5982 4.26116 17.1022 4.26116Z",
    fill: "#1E2228"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.20623 4.63902C1.87241 4.63902 2.41245 4.09897 2.41245 3.43279C2.41245 2.76661 1.87241 2.22656 1.20623 2.22656C0.540046 2.22656 0 2.76661 0 3.43279C0 4.09897 0.540046 4.63902 1.20623 4.63902Z",
    fill: "#1E2228"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.20623 10.2074C1.87241 10.2074 2.41245 9.66733 2.41245 9.00115C2.41245 8.33497 1.87241 7.79492 1.20623 7.79492C0.540046 7.79492 0 8.33497 0 9.00115C0 9.66733 0.540046 10.2074 1.20623 10.2074Z",
    fill: "#1E2228"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.20623 15.7757C1.87241 15.7757 2.41245 15.2357 2.41245 14.5695C2.41245 13.9033 1.87241 13.3633 1.20623 13.3633C0.540046 13.3633 0 13.9033 0 14.5695C0 15.2357 0.540046 15.7757 1.20623 15.7757Z",
    fill: "#1E2228"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.afde471bfddc2cb5296a86c5a2aae1e7.svg";
export { ForwardRef as ReactComponent };